import { addUserBalance } from '../../apiClient';
import { notifications } from '@mantine/notifications';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';
import { useMutation } from '@tanstack/react-query';

const useAddUserBalance = () => {
    const entityUpdater = useEntityQueryUpdate();
    const mutation = useMutation({
        mutationKey: `add_balance`,
        mutationFn: (model) =>
            addUserBalance({
                ...model,
            }),
        onSuccess: (data) => {
            entityUpdater([['users'], ['user', data.id]], data);
            notifications.show({
                title: 'Success',
                message: `Successfully updated user balance`,
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return mutation;
};
export default useAddUserBalance;
